import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { faCoffee } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-root',
  template: `
    <!-- header -->
    <app-header></app-header>
    <!-- routes will be rendered here -->
    <router-outlet></router-outlet>
    <!-- footer -->
    <app-footer></app-footer>
  `,
  styles: []
})
export class AppComponent implements OnInit {
  faCoffee = faCoffee;

  constructor(private router: Router) {}

  ngOnInit() {
    // Redirect yoderadmin URL before Angular processes it
    const currentPath = window.location.pathname;
    if (currentPath === '/yoderadmin/login/driverview' ||
        currentPath === '/yoderadmin/login/driverview/') {
      window.location.href = 'https://drive.yodertoter.com/login/driverview';
      return;
    }

    // Detect Stripe payment redirect. With HashLocationStrategy, Stripe appends
    // query params to the base URL (before the hash), so Angular's router loads
    // the home route. We detect the params here and route to /payment-return.
    // New bookings use confirmSetup(), which redirects back with `setup_intent=`,
    // not `payment_intent=` — both must be checked or the new-booking redirect
    // path never fires.
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const setupIntentId = params.get('setup_intent');
    const paymentIntentId = params.get('payment_intent');
    if (setupIntentId || paymentIntentId) {
      const status = params.get('redirect_status') || '';
      localStorage.setItem('stripe_return_pi', setupIntentId || paymentIntentId || '');
      localStorage.setItem('stripe_return_type', setupIntentId ? 'setup_intent' : 'payment_intent');
      localStorage.setItem('stripe_return_status', status);
      // Remove Stripe params from the URL so reloads don't re-trigger
      window.history.replaceState({}, document.title, window.location.pathname);
      this.router.navigate(['/payment-return']);
    }
  }
}